import { render, staticRenderFns } from "./PredictionTable.vue?vue&type=template&id=f636d8ba&scoped=true&"
import script from "./PredictionTable.vue?vue&type=script&lang=js&"
export * from "./PredictionTable.vue?vue&type=script&lang=js&"
import style0 from "./PredictionTable.vue?vue&type=style&index=0&id=f636d8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f636d8ba",
  null
  
)

export default component.exports